import $ from 'jquery';
import 'slick-carousel';

class Tabs {
  constructor(element) {
    this.$el = $(element);
    this.$tabLabels = this.$el.children().children().children('.tab-label');
    this.$slideWrapper = this.$el.find('.tab-slide-wrapper').first();
    this.slickOptions = {
      arrows: false,
      infinite: false,
      fade: true,
      dots: false,
      slidesToShow: 1,
      waitForAnimate: false,
      touchMove: false,
      swipe: false,
      accessibility: false,
      adaptiveHeight: true
    };
    this.buildTabSlider();
    this.$tabLabels.each(function(index, label) {
      let that = this;
      $(label).on('click', (e) => that.labelClick(e, index));
    }.bind(this));
  }

  buildTabSlider(){
    this.$slideWrapper.slick(this.slickOptions);
  }

  labelClick(e, index){
    this.$tabLabels.removeClass('active');
    $(e.target).addClass('active');
    this.$slideWrapper.slick('slickGoTo', index, true);
  }
}

$('.tabs-component').each((index, element) => {
  new Tabs(element);
});
